<template>
  <div class="teacher-container" v-on:click="onPressed">
    <el-avatar
      v-if="teacher.photo"
      class="teacher-photo"
      :src="teacher.photo"
      :size="getPhotoSize()"
    />
    <div class="cover">
      <div class="name">{{ teacher.name }}</div>
      <img class="divider" src="../assets/teacher-divider.svg" />
      <img class="pointer" src="../assets/teacher-pointer.svg" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teacher: {
      id: Number,
      school_level: String,
      subject: String,
      name: String,
      photo: String,
      resume: String,
      comments: Array
    },
    onPressed: Function
  },
  methods: {
    getPhotoSize() {
      switch (this.$mq) {
        case "mobile":
          return 100;
        default:
          return 200;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.teacher-container {
  cursor: pointer;
  border-radius: 100%;
  overflow: hidden;
  text-align: center;
  position: relative;

  .teacher-photo {
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.67);
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;

    .name {
      font-size: 16px;
      font-weight: bold;
      color: #134563;
    }

    .divider {
      margin: 8px 0;
      height: 5px;
    }

    .pointer {
      margin-bottom: 2px;
      height: 37px;
    }
  }

  &:hover {
    .cover {
      display: flex;
    }
  }
}
</style>
